/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import { DecisionNodeModel } from './DecisionNodeModel';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';
import NodeWidgetHOC from '../NodeWidgetHOC/NodeWidgetHOC';
import BaseNodeWidget from '../NodeWidgetHOC/BaseNodeWidget';
import NodeTypes from '../BaseNodeModel/NodeTypes';

export class DecisionNodeFactory extends AbstractReactFactory {
  constructor() {
    super(NodeTypes.DECISION_NODE);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  generateModel(event) {
    return new DecisionNodeModel();
  }

  generateReactWidget(event) {
    const setInputFields = ({ templateName, templateId, specs }) =>
      event.model.setInputFields(templateName, templateId, specs);
    return (
      <NodeWidgetHOC node={event.model}>
        <BaseNodeWidget
          engine={this.engine}
          node={event.model}
          setInputFields={setInputFields}
        />
      </NodeWidgetHOC>
    );
  }
}
